export default __webpack_public_path__ + "static/media/matthew_chan.007b55b1.jpg";